export * from './components/Slider/index';
